import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable, of } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class TipoRNTService implements RequestCRUD<any, ResponseServiceModel> {
	private API_URL;
	private handleError: HandleError;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private enviromentGlobalService: EnviromentGlobalService) {
		this.handleError = httpErrorHandler.createHandleError('TipoRNTService');
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	get(entry: any): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}

  // Editar un nuevo tipo de RNT (Version nueva, recibe el parametro categoria)
	update(entry: any): Observable<ResponseServiceModel> {
		return this.http.put<ResponseServiceModel>(`${this.API_URL}/TipoRntAdministrador/${entry.tipo_rnt_id}`, entry).pipe(
			retry(2)
		);
	}
	create(entry: any): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}

	delete(entry: any): Observable<ResponseServiceModel> {
		return this.http.delete<ResponseServiceModel>(`${this.API_URL}/TipoRntAdministrador/${entry.tipo_rnt_id}`).pipe(
			retry(2)
		);
	}

	getTipoRNT(entry: any): Observable<ResponseServiceModel> {
		// tslint:disable-next-line:max-line-length
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/TipoRntAdministrador/Paginado?PageNumber=${entry.numeroPagina}&PageSize=12`, entry).pipe(
			retry(2)
		);
	}

	crearTipoRNT(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/TipoRntAdministrador/Crear`, entry).pipe(
			retry(2)
		);
	}

  // Lista las cetegorias asociadas a un RNT
  categoriasRnt(idRnt){
    return this.http.get<ResponseServiceModel>(`${this.API_URL}/TipoRntAdministrador/ObtenerInfoCategorias?tipo_rnt_id=${idRnt}`).pipe(
			retry(2)
		);
  }

  // Guardar un nuevo tipo de RNT (Version nueva, recibe el parametro categoria)
  crearTipoRnt(entry: any): Observable<ResponseServiceModel>{
    return this.http.post<ResponseServiceModel>(`${this.API_URL}/TipoRntAdministrador/Crear`, entry).pipe(
      retry(2)
    );
  }
}
